























































import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    Component,
    Prop,
    Vue
} from 'vue-property-decorator';
import {
    pageDataType
} from "../types";
import {
    HOST
} from "../global";
import ICountUp from 'vue-countup-v2';
import {
    TweenMax,
    TimelineLite,
    Power3,
    Power4,
    Power2,
    Back,
    TimelineMax,
} from 'gsap';
import ScrollMagic from "scrollmagic";
import gsap from 'scrollmagic';
@Component({
    name: "FullImgText",
    components: {
        ICountUp
    }
})
export default class FullImgText extends Vue {
    @Prop() readonly compData!: any;
    public HOST: string = HOST;
    delay = 1000;
    showCounter: boolean = false;

    options: any = {
        useEasing: true,
        useGrouping: true,
        separator: '',
        decimal: '.',
        prefix: '',
        suffix: ''
    };
    handleScroll(event: any) {

        let d: any = document;
        let scrollpos = window.scrollY;
        const elem = d.querySelector('.title-counterblock');
        const counterlist = (window.scrollY + window.innerHeight);
        const isHalfshown = counterlist > elem.offsetTop;
        const countbottom = elem.offsetTop + elem.height;
        const isNotscrolledPast = window.scrollY < countbottom;
        if (isHalfshown) {
            (this as any).showCounter = true;
        }
    }

    created() {
        window.addEventListener('scroll', this.handleScroll);
    }
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    public bannerAnim() {

        //text timeline

        const textline = new TimelineMax()
            .staggerFrom('.full-banner img', .6, {
                height: '40%',
                scale: 1.2,
                yPercent: 40,
                ease: Power2.easeOut,
                clearProps: 'all'
            }, .01)
            .staggerFrom('.full-textblock', .6, {
                yPercent: 60,
                autoAlpha: 0,
                ease: Power2.easeInOut,
                clearProps: 'all'
            }, .01)
            .staggerFrom('.full-textblock h2', 1, {
                yPercent: 40,
                autoAlpha: 0,
                ease: Power2.easeOut,
                clearProps: 'all'
            }, .01)
            .staggerFrom('.full-textblock p', .6, {
                yPercent: 40,
                autoAlpha: 0,
                ease: Power2.easeOut,
                clearProps: 'all'
            }, 0.01, '-=.8')
            .to('.abtext-Jumbotron', .01, {
                clearProps: 'all'
            })
        const controller3 = new ScrollMagic.Controller();
        const scene3 = new ScrollMagic.Scene({
                triggerElement: ".full-banner",
                reverse: false,
            })
            .setTween(textline)
            .addTo(controller3);

    }

    public mounted() {
        if (window.matchMedia("(min-width: 1025px)").matches) {
            this.bannerAnim();
        }

    }
}
